import { getOnboardingV1 } from '@/onboarding-homepage/api/onboarding-api';

export async function fetchHasOnboardingAccess () {
    const hasOnboardingTaskList = await getOnboardingV1();
    if (!hasOnboardingTaskList) {
        return false;
    }

    return !hasOnboardingTaskList.data.isComplete;
}
